import React from 'react';
import { PlaceholderLoader } from '@hotelplan/components.common.placeholder-loader';
import { useDeviceType } from '@hotelplan/libs.context.device-type';

const PdpRatingSkeleton = () => {
  const { mobile } = useDeviceType();

  const { w: width, h: height } = mobile
    ? { w: 374, h: 962 }
    : { w: 927, h: 725 };

  return (
    <PlaceholderLoader
      width={width}
      height={height}
      uid="cardSkeleton"
      style={{ height: '100%', width: '100%', display: 'block' }}
    >
      {mobile ? (
        <>
          <rect x="54" y="51" width="17" height="17" rx="8.5" />
          <rect x="90" y="51" width="17" height="17" rx="8.5" />
          <rect x="127" y="51" width="18" height="17" rx="8.5" />
          <rect x="108" y="51" width="18" height="17" rx="8.5" />
          <rect x="72" y="51" width="17" height="17" rx="8.5" />
          <rect y="156" width="17" height="17" rx="8.5" />
          <rect x="36" y="156" width="17" height="17" rx="8.5" />
          <rect x="73" y="156" width="18" height="17" rx="8.5" />
          <rect x="54" y="156" width="18" height="17" rx="8.5" />
          <rect x="18" y="156" width="17" height="17" rx="8.5" />
          <rect x="100" y="156" width="186" height="17" rx="5" />
          <rect y="77" width="229" height="17" rx="5" />
          <rect y="50" width="44" height="21" rx="5" />
          <rect y="110" width="210" height="22" rx="8" />
          <rect y="289" width="17" height="17" rx="8.5" />
          <rect x="36" y="289" width="17" height="17" rx="8.5" />
          <rect x="73" y="289" width="18" height="17" rx="8.5" />
          <rect x="54" y="289" width="18" height="17" rx="8.5" />
          <rect x="18" y="289" width="17" height="17" rx="8.5" />
          <rect x="100" y="289" width="186" height="17" rx="5" />
          <rect y="263" width="17" height="17" rx="8.5" />
          <rect x="36" y="263" width="17" height="17" rx="8.5" />
          <rect x="73" y="263" width="18" height="17" rx="8.5" />
          <rect x="54" y="263" width="18" height="17" rx="8.5" />
          <rect x="18" y="263" width="17" height="17" rx="8.5" />
          <rect x="100" y="263" width="186" height="17" rx="5" />
          <rect y="236" width="17" height="17" rx="8.5" />
          <rect x="36" y="236" width="17" height="17" rx="8.5" />
          <rect x="73" y="236" width="18" height="17" rx="8.5" />
          <rect x="54" y="236" width="18" height="17" rx="8.5" />
          <rect x="18" y="236" width="17" height="17" rx="8.5" />
          <rect x="100" y="236" width="186" height="17" rx="5" />
          <rect y="209" width="17" height="17" rx="8.5" />
          <rect x="36" y="209" width="17" height="17" rx="8.5" />
          <rect x="73" y="209" width="18" height="17" rx="8.5" />
          <rect x="54" y="209" width="18" height="17" rx="8.5" />
          <rect x="18" y="209" width="17" height="17" rx="8.5" />
          <rect x="100" y="209" width="186" height="17" rx="5" />
          <rect y="182" width="17" height="17" rx="8.5" />
          <rect x="36" y="182" width="17" height="17" rx="8.5" />
          <rect x="73" y="182" width="18" height="17" rx="8.5" />
          <rect x="54" y="182" width="18" height="17" rx="8.5" />
          <rect x="18" y="182" width="17" height="17" rx="8.5" />
          <rect x="100" y="182" width="186" height="17" rx="5" />
          <rect y="139" width="374" height="1" />
          <rect width="210" height="22" rx="8" />
          <rect y="29" width="374" height="1" />
          <rect y="329" width="210" height="22" rx="8" />
          <rect y="358" width="374" height="1" />
          <rect y="386" width="17" height="17" rx="8.5" />
          <rect x="36" y="386" width="17" height="17" rx="8.5" />
          <rect x="73" y="386" width="18" height="17" rx="8.5" />
          <rect x="54" y="386" width="18" height="17" rx="8.5" />
          <rect x="18" y="386" width="17" height="17" rx="8.5" />
          <rect y="621" width="41" height="17" rx="5" />
          <rect x="223" y="386" width="81" height="17" rx="5" />
          <rect y="464" width="283" height="17" rx="5" />
          <rect y="589" width="289" height="14" rx="5" />
          <rect y="492" width="255" height="14" rx="5" />
          <rect y="511" width="324" height="14" rx="5" />
          <rect y="532" width="292" height="14" rx="5" />
          <rect y="551" width="373" height="14" rx="5" />
          <rect y="570" width="341" height="14" rx="5" />
          <rect x="223" y="409" width="150" height="14" rx="5" />
          <rect x="223" y="428" width="135" height="14" rx="5" />
          <rect y="662" width="374" height="1" />
          <rect y="685" width="17" height="17" rx="8.5" />
          <rect x="36" y="685" width="17" height="17" rx="8.5" />
          <rect x="73" y="685" width="18" height="17" rx="8.5" />
          <rect x="54" y="685" width="18" height="17" rx="8.5" />
          <rect x="18" y="685" width="17" height="17" rx="8.5" />
          <rect y="920" width="41" height="17" rx="5" />
          <rect x="223" y="685" width="81" height="17" rx="5" />
          <rect y="763" width="283" height="17" rx="5" />
          <rect y="888" width="289" height="14" rx="5" />
          <rect y="791" width="255" height="14" rx="5" />
          <rect y="810" width="324" height="14" rx="5" />
          <rect y="831" width="292" height="14" rx="5" />
          <rect y="850" width="373" height="14" rx="5" />
          <rect y="869" width="341" height="14" rx="5" />
          <rect x="223" y="708" width="150" height="14" rx="5" />
          <rect x="223" y="727" width="135" height="14" rx="5" />
          <rect y="961" width="374" height="1" />
        </>
      ) : (
        <>
          <rect x="54" y="51" width="17" height="17" rx="8.5" />
          <rect x="90" y="51" width="17" height="17" rx="8.5" />
          <rect x="127" y="51" width="18" height="17" rx="8.5" />
          <rect x="108" y="51" width="18" height="17" rx="8.5" />
          <rect x="72" y="51" width="17" height="17" rx="8.5" />
          <rect y="317" width="17" height="17" rx="8.5" />
          <rect x="36" y="317" width="17" height="17" rx="8.5" />
          <rect x="73" y="317" width="18" height="17" rx="8.5" />
          <rect x="54" y="317" width="18" height="17" rx="8.5" />
          <rect x="18" y="317" width="17" height="17" rx="8.5" />
          <rect x="467" y="47" width="17" height="17" rx="8.5" />
          <rect x="503" y="47" width="17" height="17" rx="8.5" />
          <rect x="540" y="47" width="18" height="17" rx="8.5" />
          <rect x="521" y="47" width="18" height="17" rx="8.5" />
          <rect x="485" y="47" width="17" height="17" rx="8.5" />
          <rect x="567" y="47" width="186" height="17" rx="5" />
          <rect y="77" width="229" height="17" rx="5" />
          <rect x="194" y="474" width="41" height="17" rx="5" />
          <rect y="342" width="81" height="17" rx="5" />
          <rect x="194" y="317" width="283" height="17" rx="5" />
          <rect x="194" y="442" width="559" height="14" rx="5" />
          <rect x="194" y="345" width="493" height="14" rx="5" />
          <rect x="194" y="364" width="627" height="14" rx="5" />
          <rect x="194" y="385" width="565" height="14" rx="5" />
          <rect x="194" y="404" width="733" height="14" rx="5" />
          <rect x="194" y="423" width="659" height="14" rx="5" />
          <rect y="403" width="114" height="14" rx="5" />
          <rect y="365" width="150" height="14" rx="5" />
          <rect y="384" width="135" height="14" rx="5" />
          <rect y="50" width="44" height="21" rx="5" />
          <rect x="467" y="1" width="210" height="22" rx="8" />
          <rect x="467" y="180" width="17" height="17" rx="8.5" />
          <rect x="503" y="180" width="17" height="17" rx="8.5" />
          <rect x="540" y="180" width="18" height="17" rx="8.5" />
          <rect x="521" y="180" width="18" height="17" rx="8.5" />
          <rect x="485" y="180" width="17" height="17" rx="8.5" />
          <rect x="567" y="180" width="186" height="17" rx="5" />
          <rect x="467" y="154" width="17" height="17" rx="8.5" />
          <rect x="503" y="154" width="17" height="17" rx="8.5" />
          <rect x="540" y="154" width="18" height="17" rx="8.5" />
          <rect x="521" y="154" width="18" height="17" rx="8.5" />
          <rect x="485" y="154" width="17" height="17" rx="8.5" />
          <rect x="567" y="154" width="186" height="17" rx="5" />
          <rect x="467" y="127" width="17" height="17" rx="8.5" />
          <rect x="503" y="127" width="17" height="17" rx="8.5" />
          <rect x="540" y="127" width="18" height="17" rx="8.5" />
          <rect x="521" y="127" width="18" height="17" rx="8.5" />
          <rect x="485" y="127" width="17" height="17" rx="8.5" />
          <rect x="567" y="127" width="186" height="17" rx="5" />
          <rect x="467" y="100" width="17" height="17" rx="8.5" />
          <rect x="503" y="100" width="17" height="17" rx="8.5" />
          <rect x="540" y="100" width="18" height="17" rx="8.5" />
          <rect x="521" y="100" width="18" height="17" rx="8.5" />
          <rect x="485" y="100" width="17" height="17" rx="8.5" />
          <rect x="567" y="100" width="186" height="17" rx="5" />
          <rect x="467" y="73" width="17" height="17" rx="8.5" />
          <rect x="503" y="73" width="17" height="17" rx="8.5" />
          <rect x="540" y="73" width="18" height="17" rx="8.5" />
          <rect x="521" y="73" width="18" height="17" rx="8.5" />
          <rect x="485" y="73" width="17" height="17" rx="8.5" />
          <rect x="567" y="73" width="186" height="17" rx="5" />
          <rect x="467" y="30" width="401" height="1" />
          <rect width="210" height="22" rx="8" />
          <rect y="29" width="401" height="1" />
          <rect y="271" width="210" height="22" rx="8" />
          <rect y="300" width="927" height="1" />
          <rect y="512" width="927" height="1" />
          <rect y="529" width="17" height="17" rx="8.5" />
          <rect x="36" y="529" width="17" height="17" rx="8.5" />
          <rect x="73" y="529" width="18" height="17" rx="8.5" />
          <rect x="54" y="529" width="18" height="17" rx="8.5" />
          <rect x="18" y="529" width="17" height="17" rx="8.5" />
          <rect x="194" y="686" width="41" height="17" rx="5" />
          <rect y="554" width="81" height="17" rx="5" />
          <rect x="194" y="529" width="283" height="17" rx="5" />
          <rect x="194" y="654" width="559" height="14" rx="5" />
          <rect x="194" y="557" width="493" height="14" rx="5" />
          <rect x="194" y="576" width="627" height="14" rx="5" />
          <rect x="194" y="597" width="565" height="14" rx="5" />
          <rect x="194" y="616" width="733" height="14" rx="5" />
          <rect x="194" y="635" width="659" height="14" rx="5" />
          <rect y="615" width="114" height="14" rx="5" />
          <rect y="577" width="150" height="14" rx="5" />
          <rect y="596" width="135" height="14" rx="5" />
          <rect y="724" width="927" height="1" />
        </>
      )}
    </PlaceholderLoader>
  );
};

export default PdpRatingSkeleton;
